//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoButtonColors from './demos/DemoButtonColors.vue'
import DemoButtonOutlined from './demos/DemoButtonOutlined.vue'
import DemoButtonText from './demos/DemoButtonText.vue'
import DemoButtonRounded from './demos/DemoButtonRounded.vue'
import DemoButtonIcon from './demos/DemoButtonIcon.vue'
import DemoButtonIconOnly from './demos/DemoButtonIconOnly.vue'
import DemoButtonSizing from './demos/DemoButtonSizing.vue'
import DemoButtonGroup from './demos/DemoButtonGroup.vue'
import DemoButtonRouter from './demos/DemoButtonRouter.vue'
import DemoButtonLink from './demos/DemoButtonLink.vue'
import DemoButtonBlock from './demos/DemoButtonBlock.vue'
import DemoButtonFloating from './demos/DemoButtonFloating.vue'
import DemoButtonDepressed from './demos/DemoButtonDepressed.vue'
import DemoButtonLoaders from './demos/DemoButtonLoaders.vue'
import DemoButtonPlain from './demos/DemoButtonPlain.vue'
import DemoButtonTile from './demos/DemoButtonTile.vue'
import DemoButtonSpeedDial from './demos/DemoButtonSpeedDial.vue'

// code
import {
  buttonColors,
  buttonOutlined,
  buttonText,
  buttonRounded,
  buttonIcon,
  buttonIconOnly,
  buttonSizing,
  buttonGroup,
  buttonRouter,
  buttonLink,
  buttonBlock,
  buttonFloating,
  buttonDepressed,
  buttonLoaders,
  buttonPlain,
  buttonTile,
  buttonSpeedDial,
} from './demos/code'

export default {
  components: {
    AppCardCode,

    // demos
    DemoButtonColors,
    DemoButtonOutlined,
    DemoButtonText,
    DemoButtonRounded,
    DemoButtonIcon,
    DemoButtonIconOnly,
    DemoButtonSizing,
    DemoButtonGroup,
    DemoButtonRouter,
    DemoButtonLink,
    DemoButtonBlock,
    DemoButtonFloating,
    DemoButtonDepressed,
    DemoButtonLoaders,
    DemoButtonPlain,
    DemoButtonTile,
    DemoButtonSpeedDial,
  },
  setup() {
    return {
      codeSnippets: {
        buttonColors,
        buttonOutlined,
        buttonText,
        buttonRounded,
        buttonIcon,
        buttonIconOnly,
        buttonSizing,
        buttonGroup,
        buttonRouter,
        buttonLink,
        buttonBlock,
        buttonFloating,
        buttonDepressed,
        buttonLoaders,
        buttonPlain,
        buttonTile,
        buttonSpeedDial,
      },
    }
  },
}
